import { render, staticRenderFns } from "./PointPositionManage.vue?vue&type=template&id=16ac97de&scoped=true&"
import script from "./PointPositionManage.vue?vue&type=script&lang=js&"
export * from "./PointPositionManage.vue?vue&type=script&lang=js&"
import style0 from "./PointPositionManage.vue?vue&type=style&index=0&id=16ac97de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ac97de",
  null
  
)

export default component.exports